import React from "react";
import AntdLayout, {
  Content as AntdContent,
  Footer as AntdFooter,
} from "antd/es/layout/layout";
import styled from "styled-components";
import { DesignTokens } from "../styles/design-tokens";
import { ElevationHelper } from "../helper/ElevationHelper";
import { MelcoUIApp } from "../components/other/MelcoUIApp";
import { GlobalStyles } from "../components/appearance/GlobalStyles";


const { spacings, colors, elevations } = DesignTokens;
const { createBoxShadowCSSString } = ElevationHelper;

const MainLayout = styled(AntdLayout)`
  height: 100vh;
`;

const StyledHeader = styled.div`
  padding: ${spacings.xlarge}px;
  height: auto;
  background: ${colors.main.negative};
  box-shadow: ${createBoxShadowCSSString({ level: 1 })};
  z-index: ${elevations.level1.zIndex};
  flex: none;
`;

const StyledContent = styled(AntdContent) <{ contentPadding?: boolean }>`
  overflow: auto;

  && {
    padding: ${({ contentPadding }) =>
    contentPadding ? spacings.xlarge : 0}px;
  }
`;

const StyledFooter = styled(AntdFooter)`
  padding: ${spacings.xlarge}px;
  width: 100%;
  box-shadow: ${createBoxShadowCSSString({ level: 1 })};
  z-index: ${elevations.level1.zIndex};
  flex: none;
`;

export type FixedHeaderFooterApplicationLayoutProps = {
  children: React.ReactNode;
  header?: React.ReactNode;
  footer?: React.ReactNode;
  contentPadding?: boolean;
};

export const FixedHeaderFooterApplicationLayout: React.FC<
  FixedHeaderFooterApplicationLayoutProps
> = ({ children, header, footer, contentPadding }) => (
  <MelcoUIApp>
    <GlobalStyles />
    <MainLayout>
      {header && <StyledHeader>{header}</StyledHeader>}
      <StyledContent contentPadding={contentPadding}>{children}</StyledContent>
      {footer && <StyledFooter>{footer}</StyledFooter>}
    </MainLayout>
  </MelcoUIApp>
);
